import React from "react";
import { Container } from "./styles";
import logo from "../../images/logo.png";
import userPhoto from "../../images/user.png";
import { useAuth } from "../../hooks/AuthContext";
import { useNavigate } from "react-router-dom";

const HeaderAssociado = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <Container>
      <div className="left-content">
        <div
          className="logo"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/associado/home")}
        >
          <img src={logo} alt="Guruseg" />
        </div>
      </div>

      <div className="user-info">
        <p>Olá, {user?.name?.split(" ")[0] || "Associado"}</p>

        <button
          className="profile-button"
          onClick={() => navigate("/associado/perfil")}
        >
          <img src={user.photo ? user.photo_url : userPhoto} alt="Perfil" />
        </button>
      </div>
    </Container>
  );
};

export default HeaderAssociado;
